import * as React from "react";
import { useState, useCallback } from "react";

import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logo from "../../assets/images/logo.png";
import background from "../../assets/images/loginBackground.jpg";
import { IconButton, InputAdornment } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useForm } from "react-hook-form";
import { authSchema, useAuth } from "../../data/talons/Authentication/useAuth";
import { joiResolver } from "@hookform/resolvers/joi";
import { size } from "lodash";
import { color } from "../../utils/constant";
import validator from "validator";
// TODO remove, this demo shouldn't need to reset the theme.

export default function Login() {
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(authSchema),
    defaultValues: {
      email_id: "",
      password: "",
    },
  });
  const onSubmit = useCallback(
    async (data) => {
      await login(data);
    },
    // eslint-disable-next-line
    [login]
  );
  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "100vh",
        }}
      />
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={6}
        square
        sx={{ background: color.bodyBackground }}
      >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* sign in */}
          <img
            style={{ marginTop: "5rem", marginBottom: "3rem" }}
            alt="logo"
            src={logo}
          />
          <Box
            component="form"
            noValidate
            sx={{ mt: 1 }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              sx={{ borderRadius: "20px" }}
              margin="normal"
              required
              fullWidth
              id="email_id"
              label="Email Address"
              name="email_id"
              autoComplete="email"
              autoFocus
              {...register("email_id")}
              error={size(errors?.email_id?.message) > 0 ? true : false}
              helperText={
                size(errors?.email_id?.message) > 0
                  ? errors?.email_id?.message
                  : ""
              }
              InputProps={{
                style: {
                  backgroundColor: "white",
                  borderRadius: "20px",
                },
              }}
            />
            <TextField
              sx={{ borderRadius: "20px" }}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              autoComplete="current-password"
              {...register("password")}
              error={size(errors?.password?.message) > 0 ? true : false}
              helperText={
                size(errors?.password?.message) > 0
                  ? errors?.password?.message
                  : ""
              }
              InputProps={{
                style: {
                  backgroundColor: "white",
                  borderRadius: "20px",
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      //   onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {/* <Grid item xs textAlign={"right"}>
              <Link
                href="#"
                variant="body2"
                sx={{
                  textDecoration: "none",
                  color: color.forgetpassText,
                  fontWeight: "bold",
                }}
              >
                Forgot password?
              </Link>
            </Grid> */}
            <Button
              type="submit"
              fullWidth
              // onClick={() => {
              //   handleSubmit(onSubmit)();
              // }}
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: color.button,
                p: 2,
                borderRadius: "30px",
                fontWeight: "bold",
              }}
            >
              Sign In
            </Button>
            {/* <Grid container>
              <Grid item xs={12} textAlign={"center"} mt={3}>
                <Link
                  href="#"
                  variant="body1"
                  sx={{
                    textDecoration: "none",
                    color: color.forgetpassText,
                    fontWeight: "bold",
                  }}
                >
                  Don't Have An Account?{" "}
                  <span style={{ color: color.pinkText }}>Sign Up</span>
                </Link>
              </Grid>
            </Grid> */}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
